import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { ArticleApi, ArticleSearch, ArticleGridDto } from "../../../../api";
import { SearchTablePage, ViewButton, EditButton } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";

export interface IArticleListPageProps {}

export const ArticleListPage: React.FunctionComponent<IArticleListPageProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(ArticleApi);
  const history = useHistory();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: ArticleGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.article}/${row.articleId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.article}/${row.articleId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.ArticleNumber),
        fieldName: "articleNumber",
        autoFitContent: true,
      },
      {
        header: () => t(ETLCodes.BCIdentifier),
        fieldName: "bcIdentifier",
      },
      {
        header: () => t(ETLCodes.EVAT_Price),
        fieldName: "price",
        render: (row: ArticleGridDto) => <div>{row.price?.toFixed(2)}€</div>,
      },
      {
        header: () => t(ETLCodes.Description),
        fieldName: "description",
      },
    ],
    [history, t]
  );
  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.article}/0/detail/edit`);
  }, [history]);
  const search = React.useCallback((sObj) => api.baseSearch(ArticleSearch.fromJS(sObj)), [api]);
  return (
    <SearchTablePage
      addFunc={addItemFunction}
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) => api.exportXlsFile(ArticleSearch.fromJS(sObj))}
      sortKeys={{ articleNumber: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Articles) }]}
    />
  );
};
